export const createOptions = (value, allValueOptions) => {
  let valueList = [];
  value.forEach(item => {
    const curentOption = allValueOptions.find(option => option.value === item);
    valueList.push(curentOption);
  });
  return valueList;
};
